import axios from "axios";
export default {
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    data() {
        return {
            pathResource: "/rsapaidomiciliare",
            listaPaiDomiciliare: [],
            paiDomiciliare: {},
        };
    },
    methods: {
        listaPaiDomiciliareLoadData(filtroPai = null, afterLoad = null) {
            this.openShowModalLoading();
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResource;
            axios
                .get(link, { params: filtroPai })
                .then((response) => {
                    me.listaPaiDomiciliare = response.data.data.list;
                    this.closeShowModalLoading();
                    if (afterLoad != null) {
                        afterLoad();
                    }
                })
                .catch((error) => {
                    this.closeShowModalLoading();
                    console.log("Il servizio dei Pai Domiciliare ha datao errore: " + error.response.status);
                });
        },
        loadPaiDomiciliare(id, afterLoad = null) {
            if (id) {
                this.openShowModalLoading();
                let me = this;
                let link = process.env.VUE_APP_PATH_API + me.pathResource + "/" + id;
                axios
                    .get(link)
                    .then((response) => {
                        me.paiDomiciliare = response.data.data;
                        this.closeShowModalLoading();
                        if (afterLoad != null) {
                            afterLoad();
                        }
                    })
                    .catch((error) => {
                        this.closeShowModalLoading();
                        console.log("Il servizio dei Pai Domiciliare ha datao errore: " + error.response.status);
                    });
            } else {
                this.$bvToast.toast("Id non valido", {
                    title: "Attenzione",
                    variant: "danger",
                    solid: true,
                });
            }
        },
    },
};
